import { render, staticRenderFns } from "./TermPopup.vue?vue&type=template&id=19d1f628&scoped=true&"
import script from "./TermPopup.vue?vue&type=script&lang=js&"
export * from "./TermPopup.vue?vue&type=script&lang=js&"
import style0 from "./TermPopup.vue?vue&type=style&index=0&id=19d1f628&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d1f628",
  null
  
)

export default component.exports